import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { OutboundEmailDisplay } from './OutboundEmailDisplay';
import { OutboundEmailSearch } from './OutboundEmailSearch';
import { Four04 } from 'gossamer-front-end';

export const OutboundEmailRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/display/:key" element={<OutboundEmailDisplay />} />
    <Route path="/search" element={<OutboundEmailSearch />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
